import { createAsyncAction } from 'typesafe-actions';
import {
	BulkUploadResponse,
	BulkOperationStatusResponse,
	TemplateDownloadResponse,
} from 'services/lms/lmsBulkUpload.service';

export const uploadLMSFile = createAsyncAction(
	'UPLOAD_LMS_FILE_REQUEST',
	'UPLOAD_LMS_FILE_SUCCESS',
	'UPLOAD_LMS_FILE_FAILURE',
)<{ file: File }, BulkUploadResponse, string>();

export const getBulkOperationStatus = createAsyncAction(
	'GET_BULK_OPERATION_STATUS_REQUEST',
	'GET_BULK_OPERATION_STATUS_SUCCESS',
	'GET_BULK_OPERATION_STATUS_FAILURE',
)<{ bulkOperationId: string }, BulkOperationStatusResponse, string>();

export const downloadLMSTemplate = createAsyncAction(
	'DOWNLOAD_LMS_TEMPLATE_REQUEST',
	'DOWNLOAD_LMS_TEMPLATE_SUCCESS',
	'DOWNLOAD_LMS_TEMPLATE_FAILURE',
)<{ templateType: 'add' | 'edit' }, TemplateDownloadResponse, string>();

export const resetBulkUploadState = () => ({
	type: 'RESET_BULK_UPLOAD_STATE' as const,
});

export const clearBulkOperationStatus = () => ({
	type: 'CLEAR_BULK_OPERATION_STATUS' as const,
});
